<template>
  <section class="detail" >
    <div v-html="information.detail"></div>
    <dd style="margin-top:0.5rem;color: #b3b3b3;font-size:0.4rem">{{information.createtime}}</dd>
</section>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
      information: ""
    };
  },
  created() {
    if (!this.id) return false;
    this.getListData();
  },
  methods: {
    getListData() {
      console.log(this.id);
      this.service.informationGetList(this.id).then(res => {
        console.log(res);
        if (res.success) {
          this.information = res.data[0];
          this.information.createtime = this.tools.formateDate(
            new Date(this.information.createtime),
            "yyyy-MM-dd hh:mm:ss"
          );
        }
      });
    }
  }
};
</script>
<style>
.detail img {
  width: 98% !important;
  height: inherit !important;
}
.detail h5 h6,
.detail h5 > *,
.detail h6 > * {
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.detail h1,
.detail h1 > * {
  font-size: 0.5rem !important;
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.detail h2,
.detail h2 > * {
  font-size: 0.46rem !important;
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.detail h3,
.detail h3 > * {
  font-size: 0.42rem !important;
  letter-spacing: 0.06rem;
  color: #3a3f43 !important;
}
.detail h4,
.detail h4 > * {
  font-size: 0.38rem !important;
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.detail > div > p {
  font-size: 0.4rem !important;
  color: #666;
  letter-spacing: 0.02rem;
}
.detail > div > p > span {
  font-size: 0.4rem;
  color: #666;
  letter-spacing: 0.02rem;
}

.detail > div a {
  font-size: 0.4rem;
  color: #666;
  letter-spacing: 0.02rem;
}
strong {
  font-size: inherit !important;
}
</style>

<style lang="scss" scoped>
img {
  width: 100% !important;
}
.detail {
  padding: 0.8rem 0.6rem;
  width: 100%;
  overflow: hidden;
  p img {
    width: 100px;
  }

  h1 {
    font-size: 0.5rem !important;
  }
}
</style>





// WEBPACK FOOTER //
// Consultation.vue?aeb99bd2